// extracted by mini-css-extract-plugin
export default {"pdf-page-canvas":"Programacao_pdf-page-canvas__mRaqT","pdf-loading":"Programacao_pdf-loading__DqxYa","pdf-controls":"Programacao_pdf-controls__QiNhz"};